module.exports = __webpack_public_path__ + "img/pichincha.199f191.png";